import { all, call, put, takeLatest, select, actionChannel } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaLeadTypes } from './sagaLeadRedux';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';
import { push } from 'react-router-redux';
import { buildUrl, getCurrentUserId } from '../../helpers/utility';

export function* requestGetLeads(action) {
    const tag = '[REQUEST_GET_LEADS]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetLeads, jwtToken, branchId, culture, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetLeads response :`, response.data);
                yield put(Actions.getLeadsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetLeads failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getLeadsFailure(message));
    }
}

export function* requestUpdateLeadBatch(action) {
    const tag = '[REQUEST_UPDATE_LEAD_BATCH]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateLeadBatch, jwtToken, branchId, culture, action.updateLeadBatch);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateLeadBatch response :`, response.data);
                yield put(Actions.updateLeadBatchSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateLeadBatch failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateLeadBatchFailure(message));
    }
}

export function* requestGenerateLeadReport(action) {
    const tag = '[REQUEST_GENERATE_LEAD_REPORT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateLeadReport, jwtToken, branchId, culture, action.leadReportInput);
            if (response.status === 200 && response.data.statusCode === 200) {
                window.open(response.data.result, '_blank');
                console.log(`${tag} requestGenerateLeadReport response :`, response.data);
                yield put(Actions.generateLeadReportSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGenerateLeadReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateLeadReportFailure(message));
    }
}
export function* requestGetLeadDetail(action) {
    const tag = '[REQUEST_GET_LEAD_DETAIL]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        if (jwtToken && culture && branchId) {
            const response = yield call(API.requestGetLeadDetail, jwtToken, branchId, culture, action.leadId, action.propertyId, userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetLeadDetail response :`, response.data);
                yield put(Actions.getLeadDetailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetLeadDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getLeadDetailFailure(message));
    }
}
export function* requestUpdateLeadDetail(action) {
    const tag = '[REQUEST_UPDATE_LEAD_DETAIL]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            const response = yield call(API.requestUpdateLeadDetail, jwtToken, action.leadDetail);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateLeadDetail response :`, response.data);
                yield put(Actions.updateLeadDetailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateLeadDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateLeadDetailFailure(message));
    }
}
export function* requestRemoveLeadDetail(action) {
    const tag = '[REQUEST_REMOVE_LEAD_DETAIL]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            const response = yield call(API.requestRemoveLeadDetail, jwtToken, action.leadId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemoveLeadDetail response :`, response.data);
                yield put(Actions.removeLeadDetailSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/account/lead`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemoveLeadDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removeLeadDetailFailure(message));
    }
}

export function* requestCreateLeadByEnquiry(action) {
    const tag = '[REQUEST_CREATE_LEAD_BY_ENQUIRY]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken && culture && branchId) {
            const response = yield call(API.requestCreateLeadByEnquiry, jwtToken, branchId, culture, action.enquiryId, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestCreateLeadByEnquiry response :`, response.data);
                yield put(Actions.createLeadByEnquirySuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateLeadByEnquiry failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.createLeadByEnquiryFailure(message));
    }
}
export function* requestDeleteLeads(action) {
    const tag = '[REQUEST_DELETE_LEADS]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        if (jwtToken && culture && branchId) {
            const response = yield call(API.requestDeleteLeads, jwtToken, branchId, userId, culture, action.leadIds);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteLeads response :`, response.data);
                yield put(Actions.deleteLeadsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteLeads failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deleteLeadsFailure(message));
    }
}

export function* requestGetLeadsByProperty(action) {
    const tag = '[REQUEST_GET_LEADS_BY_PROPERTY]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        if (jwtToken && culture && branchId) {
            const response = yield call(API.requestGetLeadsByProperty, jwtToken, branchId, culture, userId, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetLeadsByProperty response :`, response.data);
                yield put(Actions.getLeadsByPropertySuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetLeadsByProperty failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getLeadsByPropertyFailure(message));
    }
}
export default function* rootSaga() {
    yield all([
        takeLatest(SagaLeadTypes.REQUEST_GET_LEADS, requestGetLeads),
        takeLatest(SagaLeadTypes.REQUEST_UPDATE_LEAD_BATCH, requestUpdateLeadBatch),
        takeLatest(SagaLeadTypes.REQUEST_GENERATE_LEAD_REPORT, requestGenerateLeadReport),
        takeLatest(SagaLeadTypes.REQUEST_GET_LEAD_DETAIL, requestGetLeadDetail),
        takeLatest(SagaLeadTypes.REQUEST_UPDATE_LEAD_DETAIL, requestUpdateLeadDetail),
        takeLatest(SagaLeadTypes.REQUEST_REMOVE_LEAD_DETAIL, requestRemoveLeadDetail),
        takeLatest(SagaLeadTypes.REQUEST_CREATE_LEAD_BY_ENQUIRY, requestCreateLeadByEnquiry),
        takeLatest(SagaLeadTypes.REQUEST_DELETE_LEADS, requestDeleteLeads),
        takeLatest(SagaLeadTypes.REQUEST_GET_LEADS_BY_PROPERTY, requestGetLeadsByProperty),

    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaLead/sagaLeadSaga.ts